import api from './api';
import store from '@/store';
import { transformPartnerList } from '../utils/elasticResultTransformers';

export default {
  getPartnersList(includeDisabled = true) {
    const params = {
      paginate: 500,
      page: 1,
      orderby: [{ 'name.keyword': 'asc' }],
      search: store.getters.PartnerSearch,
      filters: {},
      terms: !includeDisabled ? { enabled: [true] } : {},
      ranges: [],
      fields: { ...['contact', 'enabled', 'id', 'name', 'parent_id'] }
    };

    if (store.getters.UserHasRole('Provider') || store.getters.UserHasRole('Partner')) {
      params.terms = { id: store.getters.UserBusinesses };
    }

    return api.get('partner/search', { params }).then(response => ({ data: transformPartnerList(response.data) }));
  },

  getPartner(id) {
    const params = {
      includes: 'excludedBusinesses,excludedJourneys,users,campaigns'
    };

    return new Promise((resolve, reject) => {
      api
        .get(`business/${id}`, { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getPartnerChildren(id) {
    let where = [['parent_id', '=', id]];

    const params = {
      orderby: 'name,asc',
      filters: {
        where: where,
        withCount: ['referrals']
      }
    };

    return new Promise((resolve, reject) => {
      api
        .get(`business`, { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  register(partner) {
    const details = {
      business: {
        commercialName: partner.name,
        type: 'partner'
      },
      firstName: partner.user.firstName,
      lastName: partner.user.lastName,
      email: partner.user.email,
      phone: partner.user.phone,
      parent_id: partner.parent_id,
      sub_domain: partner.subdomain,
      logo: partner.logo,
      web_site_header: partner.web_site_header,
      web_strapline: partner.web_strapline,
      web_link: partner.web.url,
      web_content: partner.web.content,
      comms_link: partner.comms.url,
      comms_headline: partner.comms.headline,
      comms_content: partner.comms.content,
      comms_logo: partner.comms.logo,
      elite: partner.elite,
      branded_site: partner.branded
    };

    return new Promise((resolve, reject) => {
      api
        .post('register', { details })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  update(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`partner/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updateCampaign(updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`campaign/${updates.id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  addCampaign(updates) {
    return new Promise((resolve, reject) => {
      api
        .post(`campaign`, updates)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getFunderCompanies() {
    let filters = {
      whereHas: [
        {
          relation: 'businessType',
          filters: { where: [['name', '=', 'provider']] }
        }
      ]
    };
    const params = {
      orderby: 'name,asc',
      filters
    };
    return new Promise((resolve, reject) => {
      api
        .get('business', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  attachExcludedBusiness(id, excludedBusinessId) {
    return new Promise((resolve, reject) => {
      api
        .put(`business/${id}/attach-excluded-business`, { excluded_business_id: excludedBusinessId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  detachExcludedBusiness(id, excludedBusinessId) {
    return new Promise((resolve, reject) => {
      api
        .put(`business/${id}/detach-excluded-business`, { excluded_business_id: excludedBusinessId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  attachExcludedJourney(id, excludedJourneyId) {
    return new Promise((resolve, reject) => {
      api
        .put(`business/${id}/attach-excluded-journey`, { excluded_journey_id: excludedJourneyId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  detachExcludedJourney(id, excludedJourneyId) {
    return new Promise((resolve, reject) => {
      api
        .put(`business/${id}/detach-excluded-journey`, { excluded_journey_id: excludedJourneyId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
